/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Team_Api_KeysInputs */



/**
* | output |
* | --- |
* | "API keys (API usage is charged, incl. oneAI Standard)" |
*
* @param {Plan_Feature_Team_Api_KeysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_api_keys = /** @type {((inputs?: Plan_Feature_Team_Api_KeysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_Api_KeysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel (API-Nutzung kostenpflichtig, inkl. oneAI Standard)")
	return /** @type {LocalizedString} */ ("API keys (API usage is charged, incl. oneAI Standard)")
});